module.exports = __webpack_public_path__ + "media/images/admin/icons/stop-circle-071bf69e2f4eea9a7e2548ef1088b28f.svg";